<template>
  <AjaxBar
    ref="bar"
    position="top"
    animate="false"
    color="primary"
    size="2px"
    indeterminate
  />
  <q-layout view="hHh lpR fFf">
    <q-header
      bordered
      class="bg-page"
    >
      <q-toolbar class="flex">
        <!-- Top Left -->
        <div
          class="toolbar__top_left flex"
          style="flex: 1; justify-content: left; align-items: center;"
        >
          <slot name="top_left">
            <q-btn
              flat
              icon="las la-arrow-left"
              color="primary"
              @click="history_back"
            />
          </slot>
        </div>

        <!-- Center Slot -->
        <div
          class="toolbar__center flex"
          style="flex: 3; justify-content: center "
        >
          <slot name="header" />
        </div>

        <!-- User Menu -->
        <div
          class="toolbar__menu flex"
          style="flex: 1; justify-content: right;"
        >
          <UserMenu :locale="$page.props.auth.locale" />
        </div>
      </q-toolbar>
      <q-banner
        v-if="$page.props.shared.banner"
        class="wide_layout_banner text-white q-py-xs"
        style="border-radius: 0px"
      >
        {{ $page.props.shared.banner }}
      </q-banner>
    </q-header>

    <q-page-container>
      <slot />
    </q-page-container>

    <q-footer
      v-if="$slots.footer"
      flat
      bordered
    >
      <slot name="footer" />
    </q-footer>
  </q-layout>
</template>

<script>
// Quasar language packs
import frQuasar from "quasar/lang/fr";
import enQuasar from "quasar/lang/en-US";

import AjaxBar from '@/shared/ajax_bar.vue';
import UserMenu from '@/shared/user_menu.vue';

export default {
  components: {
    AjaxBar,
    UserMenu,
  },
  data() {
    return {
      drawer: false,
    };
  },
  watch: {
    "shared.intercom.chat_messages_allowed": {
      handler(allowed) {
        if (allowed) {
          this.$intercom.launcher_show();
        } else {
          this.$intercom.launcher_hide();
        }
      },
      immediate: true,
    },
  },
  beforeUpdate() {
    this.switch_locale(this.$page.props.auth.locale);
  },
  beforeMount() {
    this.switch_locale(this.$page.props.auth.locale);
  },
  mounted() {
    this.$intercom.initialize(this.$page.props.shared.intercom.settings);
    if (this.$page.props.shared.intercom.chat_messages_allowed) {
      this.$intercom.launcher_show();
    }
  },
  unmounted() {
    this.$intercom.launcher_close();
  },
  methods: {
    switch_locale(locale) {
      let new_locale;
      switch (locale) {
      case "fr":
        new_locale = frQuasar;
        break;
      case "en":
        new_locale = enQuasar;
        break;
      default:
        new_locale = frQuasar;
      }
      if (new_locale.isoName != this.$q.lang.isoName) {
        this.$q.lang.set(new_locale);
      }
    },
    history_back() {
      window.history.back();
    }
  },
};
</script>

<style scoped>
.wide_layout_banner {
  background: linear-gradient(135deg, #ff7a18 0%, #ff3d4a 100%);
}
</style>
